package org.example.project.dashboard

data class DashboardFeedDefinition(
    val key: String,
    val label: String,
    val icon: String,
    val targetKey: String,
    val defaultNodes: Set<String>
)

object DashboardFeedRegistry {
    const val FEED_CHAT = "chat"
    const val FEED_SUPPORT = "support"
    const val FEED_CR = "cr"
    const val FEED_SLOT = "slot"
    const val FEED_YARD = "yard"

    val definitions = listOf(
        DashboardFeedDefinition(
            key = FEED_CHAT,
            label = "Chat",
            icon = "images/chat.svg",
            targetKey = "ChatModuleScreen",
            defaultNodes = setOf(DashboardNode.SYS, DashboardNode.CUS, DashboardNode.NET)
        ),
        DashboardFeedDefinition(
            key = FEED_SUPPORT,
            label = "Support",
            icon = "images/support.svg",
            targetKey = "SYSSupportScreen",
            defaultNodes = setOf(DashboardNode.SYS)
        ),
        DashboardFeedDefinition(
            key = FEED_CR,
            label = "CR",
            icon = "images/cr.svg",
            targetKey = "SYSCRScreen",
            defaultNodes = setOf(DashboardNode.SYS)
        ),
        DashboardFeedDefinition(
            key = FEED_SLOT,
            label = "Slot",
            icon = "images/slotverwaltung.svg",
            targetKey = "SlotView",
            defaultNodes = setOf(DashboardNode.CUS, DashboardNode.NET)
        ),
        DashboardFeedDefinition(
            key = FEED_YARD,
            label = "Yard",
            icon = "images/lager.svg",
            targetKey = "LeitstandHofScreen",
            defaultNodes = setOf(DashboardNode.CUS, DashboardNode.NET)
        )
    )

    fun definition(key: String): DashboardFeedDefinition? =
        definitions.firstOrNull { it.key == key }

    fun defaultConfig(): Map<String, Map<String, String>> =
        definitions.associate { definition ->
            definition.key to mapOf(
                DashboardNode.SYS to (DashboardNode.SYS in definition.defaultNodes).toString(),
                DashboardNode.CUS to (DashboardNode.CUS in definition.defaultNodes).toString(),
                DashboardNode.NET to (DashboardNode.NET in definition.defaultNodes).toString()
            )
        }
}
